"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Text = _interopRequireDefault(require("../Text"));
var _Title = _interopRequireDefault(require("../Title"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Expander = _interopRequireDefault(require("../Expander"));
var _SectionTileGroup = _interopRequireDefault(require("../SectionTileGroup"));
var _constant = require("../constant");
var _npsTagSelector = _interopRequireDefault(require("./nps.tag.selector.proptypes"));
var _constant2 = require("./constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SubTagContainer = _styledComponents.default.div.withConfig({
  displayName: "NpsTagSelector__SubTagContainer",
  componentId: "sc-uad02l-0"
})(["display:flex;flex-direction:column;margin-top:", ";min-height:51px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.small;
});
var ExpanderWrapper = _styledComponents.default.div.withConfig({
  displayName: "NpsTagSelector__ExpanderWrapper",
  componentId: "sc-uad02l-1"
})(["display:grid;", " ", " ", ""], function (_ref2) {
  var marginBottom = _ref2.marginBottom,
    theme = _ref2.theme;
  return marginBottom && (0, _styledComponents.css)(["margin-bottom:", ";"], theme.space[marginBottom]);
}, function (_ref3) {
  var activeTag = _ref3.activeTag,
    theme = _ref3.theme;
  return !activeTag ? (0, _styledComponents.css)(["grid-gap:", ";"], theme.space.small) : (0, _styledComponents.css)(["grid-gap:0px;"]);
}, function (_ref4) {
  var deviceType = _ref4.deviceType,
    activeTag = _ref4.activeTag;
  return deviceType === _constant.DEVICE_TYPE.DESKTOP && !activeTag && (0, _styledComponents.css)(["grid-template-columns:repeat(2,1fr);"]);
});
var NpsTagSelector = function NpsTagSelector(props) {
  var theme = props.theme,
    defaultActiveTag = props.defaultActiveTag,
    accessible = props.accessible,
    maintagList = props.maintagList,
    subtagList = props.subtagList,
    selectText = props.selectText,
    heading = props.heading,
    marginBottom = props.marginBottom,
    getSelectedData = props.getSelectedData,
    randomizeTags = props.randomizeTags,
    deviceType = props.deviceType,
    multipleSelectedData = props.multipleSelectedData;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var _useState = (0, _react.useState)(defaultActiveTag),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    activeTag = _useState2[0],
    setActiveTag = _useState2[1];
  var _useState3 = (0, _react.useState)(multipleSelectedData),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    subtag = _useState4[0],
    setSubtag = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    dataArray = _useState6[0],
    setDataArray = _useState6[1];
  var _useState7 = (0, _react.useState)(multipleSelectedData),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    resetMultipleSelectedData = _useState8[0],
    setResetMultipleSelectedData = _useState8[1];

  /**
   * Set activeTag state When a Main tag is clicked
   * @param {string} arg main tag value
   */
  var getData = function getData(arg) {
    if (!arg) {
      setSubtag(null);
      setResetMultipleSelectedData([]);
    }
    setActiveTag(arg);
  };

  /**
   * Set subtag state when any subtag is selected
   * @param {array} val Selected Sub Tag Array
   */
  var clickHandler = function clickHandler(val) {
    setSubtag(val);
  };

  /**
   * Shuffles the Array
   * @param {array} array The array to be shuffled
   */
  function shuffleArray(array) {
    array.sort(function () {
      return Math.random() - 0.5;
    });
    return array;
  }
  (0, _react.useEffect)(function () {
    if (maintagList) setDataArray(randomizeTags ? shuffleArray(JSON.parse(JSON.stringify(maintagList))) : maintagList);
  }, [maintagList, randomizeTags]);
  (0, _react.useEffect)(function () {
    if (defaultActiveTag) {
      setActiveTag(defaultActiveTag);
      getData(defaultActiveTag);
    }
  }, [defaultActiveTag]);
  (0, _react.useEffect)(function () {
    getSelectedData({
      maintag: activeTag,
      subtag: subtag
    });
  }, [activeTag, subtag]);
  var getTags = function getTags() {
    return dataArray && dataArray.map(function (el) {
      return /*#__PURE__*/_react.default.createElement(_Expander.default, (0, _extends2.default)({
        accessible: accessible,
        show: activeTag ? activeTag === el.id : true
      }, el, {
        getData: getData,
        afterIcon: _constant2.DEFAULT_STYLES.EXPANDER.ICON,
        openByDefault: !!defaultActiveTag && activeTag === el.id
      }), /*#__PURE__*/_react.default.createElement(SubTagContainer, {
        tabIndex: tabIndex,
        id: "subtag-container"
      }, /*#__PURE__*/_react.default.createElement(_Text.default, {
        accessible: accessible,
        type: _constant2.DEFAULT_STYLES.INSTRUCTION.TYPE,
        marginBottom: _constant2.DEFAULT_STYLES.INSTRUCTION.MARGIN_BOTTOM
      }, selectText), /*#__PURE__*/_react.default.createElement(_SectionTileGroup.default, {
        accessible: accessible,
        isMultipleChoiceAllowed: true,
        minHeight: _constant2.DEFAULT_STYLES.SECTION_TILE_GROUP.MIN_HEIGHT,
        alignCenter: true,
        defaultBorderColor: _constant2.DEFAULT_STYLES.SECTION_TILE_GROUP.BORDER_COLOR,
        multipleSelectedData: resetMultipleSelectedData,
        numOfCol: _constant2.DEFAULT_STYLES.SECTION_TILE_GROUP.NO_OF_COLUMNS,
        enableHover: false,
        activeTitleColor: _constant2.DEFAULT_STYLES.SECTION_TILE_GROUP.ACTIVE_TITLE_COLOR,
        titleType: _constant2.DEFAULT_STYLES.SECTION_TILE_GROUP.TITLE_TYPE,
        activeBackGroundColor: _constant2.DEFAULT_STYLES.SECTION_TILE_GROUP.ACTIVE_BG_COLOR,
        data: subtagList.filter(function (e) {
          return e.subtagId === el.subtagId;
        }),
        onClick: clickHandler
      })));
    });
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Title.default, {
      accessible: accessible,
      marginBottom: _constant2.DEFAULT_STYLES.HEADING.MARGIN_BOTTOM,
      type: _constant2.DEFAULT_STYLES.HEADING.TYPE
    }, heading), /*#__PURE__*/_react.default.createElement(ExpanderWrapper, {
      marginBottom: marginBottom,
      tabIndex: tabIndex,
      activeTag: activeTag,
      deviceType: deviceType
    }, getTags()));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
NpsTagSelector.propTypes = _npsTagSelector.default.PropTypes;
NpsTagSelector.defaultProps = _npsTagSelector.default.DefaultProps;
var _default = NpsTagSelector;
exports.default = _default;